import { useState } from "react";
import { Loader2, Package, Send } from "lucide-react";
import { toast } from "sonner";
import { http, errMsg, fmtDate } from "../../lib/api";

export const PostalApproval = ({ repair, onSaved }) => {
  const [busy, setBusy] = useState(false);
  const sent = !!repair.postal_sent_at;
  const send = async () => {
    setBusy(true);
    try {
      const { data } = await http.post(`/admin/repairs/${repair.ref}/send-postal`);
      onSaved(data);
      toast.success(`Postal address sent to ${repair.email}`);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div data-testid="postal-approval" className="mt-6 border border-ember/40 bg-ember/[0.06] p-5">
      <p className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-amber-400"><Package className="h-3.5 w-3.5" /> Customer will post it</p>
      <p className="mt-2 text-sm text-slate-300">
        {sent ? `Postal address and packing tips sent ${fmtDate(repair.postal_sent_at)}.` : "Approve this request to email the customer your postal address and packing tips."}
      </p>
      <button data-testid="send-postal-btn" onClick={send} disabled={busy} className="mt-4 inline-flex items-center gap-2 bg-ember px-4 py-2.5 text-sm font-semibold text-ink hover:bg-amber-400 disabled:opacity-60">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
        {sent ? "Send again" : "Approve & send postal address"}
      </button>
    </div>
  );
};
